// CustomArrows.jsx
export function NextArrow({ onClick }) {
  return (
    <div
      className="custom-arrow next"
      onClick={onClick}
    >
      <i className="icofont-arrow-right"></i>
    </div>
  );
}

export function PrevArrow({ onClick }) {
  return (
    <div
      className="custom-arrow prev"
      onClick={onClick}
    >
      <i className="icofont-arrow-left"></i>
    </div>
  );
}